import React from 'react';

// 演習画面の手順の進み具合。いまの手順を青く、済んだ手順に✓を付ける
// （何をどの順にするかを見出しの位置で常に示す）。
// 既定は X-1（部品を選んで次へ進む）。X-2 は SIMULATION_STEPS を steps に渡す（2026-10-10追加）。
// done: 手順ごとの済み（順番どおりでなくても、済んだ手順には✓を付ける）
const PART_SELECT_STEPS = ['おかしい箇所を選ぶ（赤く表示されます）', '【次に進む】を押す'];

export const SIMULATION_STEPS = {
  shape: ['【次のステップ】を押して、形が「誤り→中間→モチーフ」と変わる様子を見る', '右の説明シートの空欄をすべて選ぶ', '【決定】を押す'],
  gaze: ['【視点を変えておかしさを解消する】を押して、見え方が変わる様子を見る', '右の説明シートの空欄をすべて選ぶ', '【決定】を押す'],
};

/** X-2 の「いまの手順」：シミュレーションを見た → 空欄を埋めた の順で進める */
export function simulationStep(viewed, filled) {
  return !viewed ? 1 : !filled ? 2 : 3;
}

export default function StepGuide({ current, steps = PART_SELECT_STEPS, done = [] }) {
  return (
    <span className="step-guide">
      {steps.map((label, i) => {
        const n = i + 1;
        const state = done[i] || n < current ? 'done' : n === current ? 'current' : 'todo';
        return (
          <span key={n} className={`step-guide__item step-guide__item--${state}`}>
            <span className="step-badge">{state === 'done' ? '✓' : n}</span>
            {label}
          </span>
        );
      })}
    </span>
  );
}
